/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import TableGridWithFeatures from '../../../../../../SharedModules/Table/TableGridWithFeatures';
import { exportPDF } from '../utils/ResearchExportPdf';

/* THis Component loads the details in the GRID of DPL */
const ResearchExistingCMS64ReportTable = ({
  setFullScreen,
  reportData,
  header,
  handleResearchAdjustments,
  handleResearchPayments,
  responseCMSRpt,
}) => {
  const [tableData, setTableData] = useState([]);
  const [fullScreenView, setFullScreenView] = useState(false);

  const gridData = useSelector(
    (state) => state?.sharedState?.QuarterlyMarketingDataReducer?.gridData
  );
  const handleFullScreenViewClick = () => {
    setFullScreenView(!fullScreenView);
    setFullScreen(!fullScreenView);
  };

  const history = useHistory();
  const navigateToPage = (pathName, value) => {
    const updateTabs =
      JSON.parse(localStorage.getItem('tabItemsData')) == null
        ? []
        : JSON.parse(localStorage.getItem('tabItemsData'));
    if (updateTabs.findIndex((item) => item.navTo === pathName) === -1) {
      updateTabs.push({
        navTo: pathName,
        value: value,
      });
      localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
    }

    history.push({
      pathname: pathName,
    });
  };

  useEffect(() => {
    setTableData(gridData);
  }, [gridData]);

  const userDefaults = useSelector(
    (state) => state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
  );
  const logInUser = useSelector(
    (state) => state?.sharedState?.SharedReducer?.logInUser
  );
  const dispatch = useDispatch();
  const customPDFExport = (fname) => {
    const fileName = fname || 'CMS Quarterly Report';
    const columns = header.filter((item) => item.field !== '');
    exportPDF(
      reportData,
      userDefaults,
      columns,
      fileName,
      logInUser,
      dispatch,
      responseCMSRpt
    );
  };
  return (
    <>
      <div className="researchExistingTable">
        <TableGridWithFeatures
          data-testid="QMD-cbi-table"
          fullScreenView={fullScreenView}
          handleFullScreenViewClick={handleFullScreenViewClick}
          handleFullScreenView={handleFullScreenViewClick}
          gridHeight={fullScreenView ? '100vh' : null}
          rowData={reportData}
          columnDefs={header}
          exportFile
          customPDFExport={customPDFExport}
          sideBar={false}
          isScrollOn
          noGlobalSort
          researchActions
          handleResearchInvoiceAmount={() => {
            navigateToPage(
              '/researchExistingCMS64InvoiceAmount',
              'Research CMS 64 Inv Amts'
            );
          }}
          handleResearchAdjustments={handleResearchAdjustments}
          handleResearchPayments={handleResearchPayments}
          singleClickEdit={false}
          fileName="Drug Rebate Details"
          frameworkComponents={{
            drugRebate: (cellInfo) => {
              const name = cellInfo.data && cellInfo.data.name;
              if (name && name.length > 18) {
                return (
                  <OverlayTrigger
                    placement="bottom"
                    overlay={<Tooltip id="labeler-tooltip">{name}</Tooltip>}
                  >
                    <div>{name}</div>
                  </OverlayTrigger>
                );
              }
              return <div>{name}</div>;
            },
          }}
        />
      </div>
    </>
  );
};

export default ResearchExistingCMS64ReportTable;
